import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useDeleteTag = (id) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();
	const history = useHistory();

	const destroy = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(`/book-tags/${id}`);
		await queryClient.invalidateQueries("tags");
		return response;
	};

	return useMutation(destroy, {
		onSuccess: () => {
			toast.success("Tag deleted successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useDeleteTag;
